import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Feature } from '@guest-widgets/shared/src/features';
import { useFeature } from '@guest-widgets/shared/src/contexts/featureContext/featureContext';
import { useWidget } from '@guest-widgets/core';

import { LocationFilter } from '../LocationFilter/LocationFilter';

import { MoreFilters } from './MoreFilters';
import { Categories } from './Categories';
import { Radius } from './Radius';
import { Dates } from './Dates';
import { AppliedFilters } from './AppliedFilters';

export const DesktopFilters = () => {
  const { isEnabled } = useFeature();
  const { widgetArea } = useWidget();
  const isWideScreen = widgetArea?.isLarge || widgetArea?.isMedium;

  return (
    <>
      <Box display={isWideScreen ? 'flex' : 'block'} justifyContent="space-between" mb={5}>
        <Container isWideScreen={isWideScreen}>
          {isEnabled(Feature.CategoryFilter) && <Categories />}
          {/* TODO: removed for now until it will be implemented Location Filter */}
          {false && isEnabled(Feature.LocationFilter) && (
            <>
              <StyledLocationFilter />
              <Radius />
            </>
          )}
          {isEnabled(Feature.DateFilter) && (
            <DatesWrapper isWideScreen={isWideScreen}>
              <Dates />
            </DatesWrapper>
          )}
        </Container>
        <MoreFilters />
      </Box>
      <AppliedFilters />
    </>
  );
};

const StyledLocationFilter = styled(LocationFilter)({
  width: 250,
});

const Container = styled(Box)<{ isWideScreen: boolean }>(({ theme, isWideScreen }) => ({
  display: isWideScreen ? 'flex' : 'block',
  gap: theme.spacing(4),
}));

const DatesWrapper = styled('div')<{ isWideScreen: boolean }>(({ theme, isWideScreen }) => ({
  marginTop: isWideScreen ? '0' : theme.spacing(6),
}));
